export var createListener = function createListener(ongoingRequests) {
  return function (_ref) {
    var message = _ref.data;
    var id = message.id;

    if (id !== null) {
      var ongoingRequest = ongoingRequests.get(id);

      if (ongoingRequest !== undefined) {
        var reject = ongoingRequest.reject,
            resolve = ongoingRequest.resolve;
        ongoingRequests.delete(id);

        if (message.error === undefined) {
          resolve(message.result);
        } else {
          reject(new Error(message.error.message));
        }
      }
    }
  };
};